<div class=" product-inner ">
    <div class="">
        <div *ngIf="isNewArrival"><span
                style="background-color: #a00e01; color: white; border-radius: 15px ;text-align: center ;padding: 3px; font-size: 12px"> -33%</span>
        </div>

        <div class="container img-cont" style="overflow: hidden;">
            <span i18n class="badge badge-danger special-pct-badge"
                  *ngIf="hasSpecialPrice">{{this.item.getDiscountPct()}}% Discount</span>
            <a (click)="goToProductDetailsPage()" href="#"
               [routerLink]="'/product/details/byk/'+encode(item.custom_attributes[1].value)+'/'+item.sku">
                <img src="{{item.getCachedImage()}}" class="img-fluid" alt="...">
            </a>

        </div>
        <div class="block-content">
            <div class="row" style="display: flex; justify-content: center; align-items: center">
                <div class="col-12">
                    <div class=" productName text-left">{{(this.item.name.length > 20) ? (this.item.name | slice:0:40) + '..' : (this.item.name)}}</div>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content: center; align-items: center">
                <div class="col-12" style="text-align: center">
                    <div>
                        <span *ngIf="!hasSpecialPrice" style="color:#454545; font-size: 18px "> {{current_currency}}
                            <label style="font-weight: 700;">{{this.price | number: this.price_format}} </label>   </span>
                        <span *ngIf="hasSpecialPrice"
                              style="color:red; font-weight: bold; font-size: 18px "> {{current_currency}} {{this.getSpecialPrice()  | number: this.price_format}}   </span>
                        <span *ngIf="hasSpecialPrice"
                              style="color: grey;text-decoration-line: line-through; font-size: 14px "> {{current_currency}}{{this.price| number: this.price_format}} </span>
                    </div>
                </div>

            </div>
            <div class=" icon-cont">
                <div class=" text-left">
                    <img *ngIf="isAdding" style="width: 40px; float:left;padding-top: 7px;" src="assets/loader.gif"/>
                    <!--                    <a *ngIf="!isAdding && getProductType()" class="btn btn-primary product-action-btn"-->
                    <!--                       style="width: 50px;"-->
                    <!--                       [routerLink]="'/product/details/byk/'+ encode(item.custom_attributes[1].value)  +'/'+item.sku"-->
                    <!--                       style="    margin-top: 10px;font-size: 15px;">-->

                    <!--                        <i class="la la-cart-plus" style="font-size: 20px;"></i>-->


                    <!--                    </a>-->
                    <div class="d-flex">


                        <a *ngIf="!isAdding && isSimpleProduct" class="btn btn-primary d-flex "
                           style="width: 50px; "
                           (click)="addItemToCart()"
                           style="    margin-top: 10px; font-size: 15px; display: inline; background-color: #34c7c7">

                            <i class="la la-cart-plus" style="font-size: 20px;"></i>
                            <span i18n="@@buy">Buy</span>


                        </a>


                        <!--                    <a *ngIf="getProductType() == false" class="btn btn-primary product-action-btn" style="width: 50px;"-->
                        <!--                       [routerLink]="'/product/details/byk/'+encode(item.custom_attributes[1].value)+'/'+item.sku"-->
                        <!--                       style="    margin-top: 10px;font-size: 15px;">-->

                        <!--                        <i class="la la-cart-plus" style="font-size: 20px;"></i>-->


                        <!--                    </a>-->
                        &nbsp;


                        <a *ngIf="isSimpleProduct" class="btn btn-primary " (click)="goToProductDetailsPage()"
                           style="  margin-top: 10px;font-size: 15px;">


                            <span i18n>    Details</span>


                        </a>


                        <a *ngIf="isSimpleProduct == false" class="btn btn-primary "
                           [routerLink]="'/product/details/byk/'+encode(item.custom_attributes[1].value)+'/'+item.sku"
                           style="    margin-top: 10px;font-size: 15px;">


                            <span i18n>    Details</span>


                        </a>

                    </div>


                </div>
                <div class="text-right">

                    <div *ngIf="isCustomer " style="display: inline-block">
                        &nbsp;
                        <a *ngIf="!checkIfItemInFavorite(item.sku) && (this.item.type_id == 'simple') "
                           class="btn btn-primary product-action-btn"
                           style="    margin-top: 10px;font-size: 15px;">

                            <i class="la la-heart" style="font-size: 20px;" (click)="addItemToWishlist($event)"></i>

                        </a>
                        <a *ngIf="checkIfItemInFavorite(item.sku) && (this.item.type_id == 'simple')"
                           class="btn btn-red product-action-btn"
                           style="    margin-top: 10px;font-size: 15px;">

                            <i class="la la-heart" style="font-size: 20px;"
                               (click)="deleteItemFromWishlist($event)"></i>

                        </a>

                    </div>


                </div>
            </div>

        </div>

    </div>
</div>

